defineDs('DanskeSpil/Domain/RetailAccount/Scripts/Helpers/Dictionary',
  [
    'Shared/Framework/Mithril/Scripts/Helpers/Dictionary'
  ],
  function (Dictionary) {

    return new Dictionary('/RetailAccount');

  });
